import React, { useEffect, useRef, useState } from "react";
import { Routes, Route, Router, Switch, Navigate } from "react-router-dom";
import MySidebar from "../src/Components/Content/Sidebar";
import Dashboard from "./pages/DashboardPage/Dashboard";
import "./index.css";
import UserSettingDashboard from "./pages/Setting/Leave/UserSettingDashboard/UserSettingDashboard";
import HolidayCalendar from "./pages/Setting/Leaveorgin/HolidayCalendar";
import EditWorkingDays from "./pages/Setting/Leaveorgin/EditWorkingDays";
import TimeOffPolicy from "./pages/Setting/Leaveorgin/TimeOffPolicy";
import LeavePreference from "./pages/Setting/Leaveorgin/LeavePreference";
import Role from "./pages/Setting/Leave/Roles1";
import LeavePage from "./pages/Setting/Leaveorgin/LeavePage";
import NotificationPreferences from "./pages/Setting/Other/NotificationPreferences/NotificationPreferences";
import SettingPreferences from "./pages/Setting/Other/SettingPreferences/SettingPreferences";
import AddExternalUser from "./pages/Setting/Leave/AddExternalUser";
import RolePermission from "./pages/Setting/Leave/RolePermission";
import StatusType from "./pages/Setting/Leave/StatusType1";
import Department from "./pages/Setting/Leave/Department1";
import Location from "./pages/Setting/Leave/location1";
import Preferences from "./pages/Setting/Leave/perferences";
import OtherSetting from "./pages/Setting/Other/OtherSetting";
import Tables from "./pages/UserPage/Tables";
import WorkingDays from "./pages/Setting/Leaveorgin/WorkingDays";
import TimeOfType from "./pages/Setting/Leaveorgin/TimeOfType";
import EditHolidayCalendar from "./pages/Setting/Leaveorgin/EditHolidayCalendar";
import EditTimeOfpolicy from "./pages/Setting/Leaveorgin/EditTimeOfpolicy";
import AddEmployee1 from "./pages/Setting/Leave/AddEmployee1";
import AddWorkingDays from "./pages/Setting/Leaveorgin/AddWorkingDays";
import EditTimeOffType from "./pages/Setting/Leaveorgin/EditTimeOffType";
import AddRestrictedDate from "./pages/Setting/Leaveorgin/AddRestrictedDate";
import LeaveNavigation from "./pages/LeaveNavigation/LeaveNavigation";
import Approval from "./pages/Approval/Approval";
import RequestForm from "./pages/Approval/RequestForm";
import UserApproval from "./pages/LeaveNavigation/UserApproval";
import AddSubholday from "./pages/Setting/Leaveorgin/AddSubholday";
import AddLeaveSetting from "./pages/Setting/Leaveorgin/AddLeaveSetting";
import EditLeaveSetting from "./pages/Setting/Leaveorgin/EditLeavePolicy";
import UpdateUser from "./pages/UserPage/UpdateUser";
import DisableAccount from "./pages/DisableAccount/DisableAccount";
import Report from "./pages/Report/Report";
import LeaveRequest from "./pages/LeaveRequest/LeaveRequest";
import AllExtrenalReport from "./pages/LeaveReport/AllExtrenalReport";
import EmployeeLeaveRequest from "./pages/LeaveReport/EmployeeLeaveRequest";
import Header from "./Components/Content/Header.jsx";
import Billing from "./pages/Billing/billing.jsx";
import DashboardSuperAdmin from "./pages/SuperAdmin/DashboardSuperAdmin.jsx";

function Main() {
  useEffect(() => {
    const isAuthenticated = sessionStorage.getItem("user") !== null;
    document.body.style.overflow = isAuthenticated ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const isAuthenticated = sessionStorage.getItem("user") !== null;

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div
      style={{
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "100vh",
      }}
    >
      <Header />
      <div style={{ display: "flex", height: "100vh" }}>
        <div className="sidebar-container">
          <MySidebar />
        </div>
        <div className="main-content p-3 ">
          <div className="content-body p-4">
            <Routes>
              <Route
                path="/users/*"
                element={
                  isAuthenticated ? (
                    <Tables />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/dashboard"
                element={
                  isAuthenticated ? (
                    <Dashboard />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/dashboard-super-admin"
                element={
                  isAuthenticated ? (
                    <DashboardSuperAdmin />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/updateusers"
                element={
                  isAuthenticated ? (
                    <UpdateUser />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/report/leave-external-report"
                element={<AllExtrenalReport />}
              />
              <Route
                path="report/leave-report-employee-leave-request"
                element={<EmployeeLeaveRequest />}
              />
              <Route
                path="/user-setting-dashboard/*"
                element={
                  isAuthenticated ? (
                    <UserSettingDashboard />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/leave-page/holiday-calander/*"
                element={
                  isAuthenticated ? (
                    <HolidayCalendar />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/leave-page/holiday-calander/edit-holiday"
                element={
                  isAuthenticated ? (
                    <EditHolidayCalendar />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/leave-page/holiday-calander/sub-holiday"
                element={
                  isAuthenticated ? (
                    <AddSubholday />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/leave-page/time-off-policy"
                element={
                  isAuthenticated ? (
                    <TimeOffPolicy />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/leave-page/time-off-policy/leave-policy-details"
                element={
                  isAuthenticated ? (
                    <EditTimeOfpolicy />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/leave-page/time-off-policy/leave-policy-details/add-restricted-dates"
                element={
                  isAuthenticated ? (
                    <AddRestrictedDate />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/leave-page/leave-preference"
                element={
                  isAuthenticated ? (
                    <LeavePreference />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/leave-page/working-days"
                element={
                  isAuthenticated ? (
                    <WorkingDays />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/leave-page/working-days/edit-working-days"
                element={
                  isAuthenticated ? (
                    <EditWorkingDays />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/leave-page/working-days/add-working-days"
                element={
                  isAuthenticated ? (
                    <AddWorkingDays />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/user-setting-dashboard/Role"
                element={
                  isAuthenticated ? <Role /> : <Navigate to="/login" replace />
                }
              />
              <Route
                path="/leave-page/*"
                element={
                  isAuthenticated ? (
                    <LeavePage />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/other-setting/notification-preferences"
                element={
                  isAuthenticated ? (
                    <NotificationPreferences />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/other-setting/setting-preferences"
                element={
                  isAuthenticated ? (
                    <SettingPreferences />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/disable-account"
                element={
                  isAuthenticated ? (
                    <DisableAccount />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/user-setting-dashboard/External"
                element={
                  isAuthenticated ? (
                    <AddExternalUser />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/user-setting-dashboard/RolePermission"
                element={
                  isAuthenticated ? (
                    <RolePermission />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/user-setting-dashboard/Status"
                element={
                  isAuthenticated ? (
                    <StatusType />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/user-setting-dashboard/AddEmployee"
                element={
                  isAuthenticated ? (
                    <AddEmployee1 />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/user-setting-dashboard/Department"
                element={
                  isAuthenticated ? (
                    <Department />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/user-setting-dashboard/Location"
                element={
                  isAuthenticated ? (
                    <Location />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/user-setting-dashboard/preferences"
                element={
                  isAuthenticated ? (
                    <Preferences />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/leave-navigation"
                element={
                  isAuthenticated ? (
                    <LeaveNavigation />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/other-setting/*"
                element={
                  isAuthenticated ? (
                    <OtherSetting />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/leave-page/leave-type"
                element={
                  isAuthenticated ? (
                    <TimeOfType />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/approval/*"
                element={
                  isAuthenticated ? (
                    <Approval />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/RequestForm"
                element={
                  isAuthenticated ? (
                    <RequestForm />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/UserApproval"
                element={
                  isAuthenticated ? (
                    <UserApproval />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/leave-page/leave-type/edit-leave-type/:leave_type_id/:leave_type_name"
                element={
                  isAuthenticated ? (
                    <EditTimeOffType />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/leave-page/leave-setting/AddLeaveSetting"
                element={
                  isAuthenticated ? (
                    <AddLeaveSetting />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/leave-page/leave-setting/EditLeaveSetting"
                element={
                  isAuthenticated ? (
                    <EditLeaveSetting />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/report"
                element={
                  isAuthenticated ? (
                    <Report />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/Leave-Request"
                element={
                  isAuthenticated ? (
                    <LeaveRequest />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/billing"
                element={
                  isAuthenticated ? (
                    <Billing />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
            </Routes>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
